import {EmployeeStatus} from "@src/CommonComponents/WorkStatus/WorkStatus.tsx";
import {CheckInOutPair} from "@src/httpClient/__generated__/Api.ts";


export const parseEmployeeStatus = (events: CheckInOutPair[]) => {
    if (!events || events?.length === 0) return EmployeeStatus.notAtWork
    const lastEvent = events[events.length - 1]
    if (lastEvent?.event_out && !lastEvent?.event_in) return EmployeeStatus.wrongData
    return lastEvent.event_out ? EmployeeStatus.clockedOut : EmployeeStatus.atWork
}
